import React, { PropTypes } from "react";
import Modal from "react-bootstrap/lib/Modal";
import ApplyExit from "../Forms/ApplyExit";
import axios from "axios";
import toastr from "toastr";

class Modals extends React.Component {

  constructor() {
    super();
    this.state = { reportingManager: null }
    this.applyExit = this.applyExit.bind(this);
    this.getRequestObject = this.getRequestObject.bind(this);

  }

  getRequestObject(data) {
    data.id = null;
    data.empId = this.props.employee.employeeCode;
    data.name = this.props.employee.name;
    data.doResignation = data.doResignation.getTime();
    if (data.doLeaving != null && data.doLeaving != 0) {
      data.doLeaving = data.doLeaving.getTime();
    }
    if (data.gardening != null && data.gardening != 0) {
      data.gardening = data.gardening.getTime();
    }
    if (data.noticePeriodStatus != 'Gardening') {
      data.gardening = null;
    }

    data.remarks = data.remarks ? data.remarks : "";
    data.status = "R";

    return data;
  }

  applyExit(data, recovery) {
    debugger;
    let request = Object.assign({}, data);
    request.recovery = recovery;
    request = this.getRequestObject(request);

    let exitData = new FormData();
    exitData.append('picture', request.file);
    exitData.append('recovery', recovery);
    exitData.append('name', request.name);
    exitData.append('doLeaving', request.doLeaving);
    exitData.append('doResignation', request.doResignation);
    exitData.append('empId', request.empId);
    exitData.append('gardening', null);
    exitData.append('noticePeriodStatus', request.noticePeriodStatus);
    exitData.append('remarks', request.remarks);
    exitData.append('status', request.status);
    exitData.append('typeOfExit', request.typeOfExit);

    let xhr = new XMLHttpRequest();
    xhr.open('POST', process.env.REQ_URL + this.props.url, true);
    xhr.responseType = 'json';
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.withCredentials = true;

    // Set up a handler for when the request finishes.
    xhr.onload = function () {
      if (xhr.status === 200) {
        this.props.close();
        this.props.refresh(request.empId);
        toastr.success("The Employee has been moved to Exit!")
        // File(s) uploaded.
      } else {
        alert('An error occurred!');
      }
    }.bind(this);
    xhr.send(exitData);
    console.log("request: ", request);
  }

  render() {
    const initialValues = {
      initialValues: {
        doResignation: this.props.employee.doR,
        doLeaving: this.props.employee.doL,
        typeOfExit: this.props.employee.typeOfExit,
        noticePeriodStatus: this.props.employee.noticePeriodStatus,
        remarks: this.props.employee.remarks
      }
    }
    console.log(83, this.props.employee);
    return (
      <Modal
        bsSize="large"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Employee Exit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ApplyExit
            {...initialValues}
            employee={this.props.employee}
            applyExit={this.applyExit}
          />
          &nbsp;

        </Modal.Body>
      </Modal>
    );
  }
}

Modals.propTypes = {};

export default Modals;




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/Exit/Modal.js
 **/